import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Observable, Subject } from "rxjs"
import { takeUntil } from "rxjs/operators"


@Injectable()
export class HttpCancelInterceptor implements HttpInterceptor {
  constructor(private httpCancelService: HttpCancelService) { }

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {

    if (
      req.url.startsWith(`https://prod.flowstudio.app/`) ||
      req.url.startsWith(`https://dev.flowstudio.app/`) ||
      req.url.startsWith(`/api/subscription`) ||
      req.url == `https://api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments?api-version=2016-11-01` ||
      req.url.startsWith(`https://login.microsoftonline.com/`)
      ) {
      return next.handle(req);
    }

    return next.handle(req).pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()))
  }
}

@Injectable()
export class HttpCancelService {
  private cancelPendingRequests$ = new Subject<void>()

  constructor() { }

  /** Cancels all pending Http requests. */
  public cancelPendingRequests() {
    this.cancelPendingRequests$.next()
  }

  public onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable()
  }

}
